// extracted by mini-css-extract-plugin
export default {"oneitem":"OneSupportDocument_oneitem__MoW16","onetoolbar":"OneSupportDocument_onetoolbar__s+Dcb","lbl":"OneSupportDocument_lbl__qwmig","modal":"OneSupportDocument_modal__pMOmS"};